import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1402202215__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Gruppe", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1402202215__cls-1{fill:none}.i-1402202215__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M147.96 43.84c0-8.75-7.12-15.88-15.87-15.88s-15.87 7.12-15.87 15.88 7.12 15.88 15.87 15.88 15.87-7.12 15.87-15.88M59.66 59.71c8.75 0 15.87-7.12 15.87-15.88s-7.12-15.88-15.87-15.88-15.87 7.12-15.87 15.88 7.12 15.88 15.87 15.88",
      class: "i-1402202215__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "96.05",
      cy: "98.16",
      r: "20.02",
      class: "i-1402202215__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M68.04 98.16c0 15.45 12.57 28.02 28.02 28.02s28.02-12.57 28.02-28.02-12.57-28.02-28.02-28.02-28.02 12.57-28.02 28.02m48.04 0c0 11.04-8.98 20.02-20.02 20.02s-20.02-8.98-20.02-20.02 8.98-20.02 20.02-20.02 20.02 8.98 20.02 20.02M49.57 150.28l-4.06 14.61 7.71 2.14 4.06-14.61c1.68-6.04 7.23-10.26 13.5-10.26h51.06c6.28 0 11.83 4.22 13.5 10.27l3.89 13.99 7.71-2.14-3.89-13.99c-2.63-9.5-11.35-16.13-21.21-16.13H70.78c-9.85 0-18.57 6.63-21.21 16.11ZM155.96 43.84c0-13.17-10.71-23.88-23.87-23.88s-23.87 10.71-23.87 23.88 10.71 23.88 23.87 23.88 23.87-10.71 23.87-23.88m-39.74 0c0-8.75 7.12-15.88 15.87-15.88s15.87 7.12 15.87 15.88-7.12 15.88-15.87 15.88-15.87-7.12-15.87-15.88M171.14 93.96l5.01 18.03 7.71-2.14-5.01-18.03c-2.63-9.5-11.36-16.13-21.22-16.13H131.6v8h26.03c6.28 0 11.83 4.22 13.51 10.27M59.66 67.71c13.16 0 23.87-10.71 23.87-23.88S72.82 19.95 59.66 19.95 35.79 30.66 35.79 43.83 46.5 67.71 59.66 67.71m0-39.75c8.75 0 15.87 7.12 15.87 15.88s-7.12 15.88-15.87 15.88-15.87-7.12-15.87-15.88 7.12-15.88 15.87-15.88M20.87 93.96c1.68-6.05 7.23-10.27 13.5-10.27h26.16v-8H34.37c-9.85 0-18.58 6.63-21.21 16.13l-5.01 18.03 7.71 2.14z",
      class: "i-1402202215__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "group"}) } }